import * as React from 'react';
import * as styles from './Title.css';

export interface ITitleProps {
  children: React.ReactNode;
}

export function Title({ children }: ITitleProps) {
  return <h1 className={styles['title']}>{children}</h1>;
}
